import React, { useEffect, useRef } from "react";
import { useContext, useState } from "react";
import NoteContext from "../context/notes/noteContext";
import NoteItem from "./NoteItem";
import { useNavigate } from "react-router-dom";

const Notes = (props) => {
  let navigate = useNavigate();
  const { showAlert } = props;
  const [note, setNote] = useState({
    id: "",
    title: "",
    description: "",
    tag: "Default",
  });

  const handleClick = (e) => {
    refclose.current.click();
    editNote(note.id, note.title, note.description, note.tag);
  };

  const handleonchange = (event) => {
    setNote({ ...note, [event.target.name]: event.target.value });
  };

  const context = useContext(NoteContext);
  const { notes, getNotes, editNote } = context;
  useEffect(() => {
    if (localStorage.getItem("token")) {
      getNotes();
    }
    else {
      props.showAlert("You are not logged in. Please login to view notes.", "danger");
      navigate("/login");
    }
    // eslint-disable-next-line
  }, []);
  const updateNote = (currentNote) => {
    ref.current.click();
    setNote({
      id: currentNote._id,
      title: currentNote.title,
      description: currentNote.description,
      tag: currentNote.tag,
    });
    // context.updateNote(note);
  };
  const ref = useRef(null);
  const refclose = useRef(null);
  return (
    <>
      <div>
        <button
          type="button"
          className="btn btn-primary d-none"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          ref={ref}
        >
          Launch demo modal
        </button>

        <div
          className="modal fade"
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          // aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div
                className="modal-header"
                style={{
                  backgroundColor: props.mode === "dark" ? "#3a4750" : "white",
                  color: props.mode === "dark" ? "white" : "black",
                }}
              >
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Edit Note
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="container">
                  <div className="mb-3">
                    <h1 id="header">{props.heading}</h1>
                    <label
                      htmlFor="title"
                      className="form-label"
                      style={{
                        backgroundColor:
                          props.mode === "dark" ? "#3a4750" : "white",
                        color: props.mode === "dark" ? "white" : "black",
                      }}
                    >
                      Title
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="title"
                      value={note.title}
                      onChange={handleonchange}
                      name="title"
                      style={{
                        backgroundColor:
                          props.mode === "dark" ? "#3a4750" : "white",
                        color: props.mode === "dark" ? "white" : "black",
                      }}
                    />
                  </div>
                  <div className="mb-3">
                    <label
                      htmlFor="description"
                      className="form-label"
                      style={{
                        backgroundColor:
                          props.mode === "dark" ? "#3a4750" : "white",
                        color: props.mode === "dark" ? "white" : "black",
                      }}
                      required
                    >
                      Description
                    </label>
                    <textarea
                      name="description"
                      id="description"
                      type="text"
                      className="form-control"
                      value={note.description}
                      rows={7}
                      onChange={handleonchange}
                      style={{
                        backgroundColor:
                          props.mode === "dark" ? "#3a4750" : "white",
                        color: props.mode === "dark" ? "white" : "black",
                        minHeight: "9em",
                        maxHeight: "19em",
                        overflowY: "auto",
                        required: { note },
                      }}
                    ></textarea>
                    <label
                      htmlFor="tag"
                      className="form-label"
                      style={{
                        backgroundColor:
                          props.mode === "dark" ? "#3a4750" : "white",
                        color: props.mode === "dark" ? "white" : "black",
                      }}
                    >
                      Tag
                    </label>
                    <select
                      className="form-control"
                      id="tag"
                      value={note.tag}
                      onChange={handleonchange}
                      name="tag"
                      style={{
                        backgroundColor:
                          props.mode === "dark" ? "#3a4750" : "white",
                        color: props.mode === "dark" ? "white" : "black",
                      }}
                    >
                      <option value="Default">Default</option>
                      <option value="Personal">Personal</option>
                      <option value="Important">Important</option>
                      <option value="Fun">Fun</option>
                      <option value="Official">Official</option>
                    </select>
                  </div>
                </div>
                <div
                  className="container my-3"
                  id="textstats"
                  style={{
                    backgroundColor:
                      props.mode === "dark" ? "#3a4750" : "white",
                    color: props.mode === "dark" ? "white" : "black",
                  }}
                >
                  <h2>Text Properties</h2>
                  <p>
                    {
                      note.description
                        .split(/\s+/)
                        .filter((word) => word.length > 0).length
                    }{" "}
                    words and {note.description.replace(/\s/g, "").length}{" "}
                    characters
                  </p>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-dark"
                  data-bs-dismiss="modal"
                  ref={refclose}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={() => {
                    handleClick();
                    props.showAlert("Note Updated Successfully", "success");
                  }}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <h2 className="my-5 mx-2">
            {notes.length === 0 && "No notes to display ...😔"}
          </h2>
          {notes.map((note) => {
            return (
              <div className="col-md-4" key={note._id}>
                <NoteItem
                  note={note}
                  updateNote={updateNote}
                  showAlert={showAlert}
                />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Notes;
